export default "__VITE_ASSET__4XWH04dd__"